import { createApp } from 'vue'
import App from './App.vue'
import '@/styles/index.scss'
import router from './router/index'
import { createPinia } from 'pinia'
import VueCesium from 'vue-cesium'
import 'vue-cesium/dist/index.css'
import '@/common/rem'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueCesium) // 将默认使用 https://unpkg.com/cesium@latest/Build/Cesium/Cesium.js

app.mount('#app')
